import { Accordion } from "src/components/Default/LekUI/Accordion";

import Content from "./Content";
import Title from "./Title";

function Paragraph({
	openedAccordions,
	setOpenedAccordions,
	index,
	section,
	deprecatedArticleId,
	className,
}) {
	const isAccordionExpanded = () => {
		return openedAccordions.some((expId) => expId === index);
	};

	const setAccordion = () => {
		if (isAccordionExpanded(index)) {
			setOpenedAccordions(openedAccordions.filter((expId) => expId !== index));
		} else {
			setOpenedAccordions([...openedAccordions, index]);
		}
	};

	return (
		<Accordion
			expanded={isAccordionExpanded(index)}
			onChange={() => setAccordion(index)}
			className={className}
		>
			<Title section={section} />
			<Content
				isOpen={isAccordionExpanded(index)}
				section={section}
				index={index}
				deprecatedArticleId={deprecatedArticleId}
			/>
		</Accordion>
	);
}

export default Paragraph;
